/**
 * Branża
 */
export const P24MerchantTrade = {

    serint: {
        id: 'serint',
        displayText: 'Serwis internetowy'
    }

}

/**
 * Kolekcja typow
 */
export const P24MerchantTradeList = Object.keys(P24MerchantTrade).map(type => P24MerchantTrade[type])

/**
 * Metoda zwracająca typ działalności bazując na identyfikatorze
 * 
 * @param {String} id identyfikator typu działalności
 * 
 * @returns {P24MerchantBusinessType} typ działalności
 */
export const getP24MerchantTradeById = (id) => {
    if (!id) {
        return P24MerchantTrade.serint;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let businessType = P24MerchantTradeList.find(item => item.id === id)
    return businessType;
}